const facebook = 'https://www.facebook.com/jettravelkft'
const instagram = 'https://www.instagram.com/jet_travel/'
const tiktok = 'https://www.tiktok.com/@jet.travel01'

export {facebook, instagram, tiktok}